import { render, staticRenderFns } from "./PostResultNotify.vue?vue&type=template&id=173e63de&scoped=true"
import script from "./PostResultNotify.vue?vue&type=script&lang=js"
export * from "./PostResultNotify.vue?vue&type=script&lang=js"
import style0 from "./PostResultNotify.vue?vue&type=style&index=0&id=173e63de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e63de",
  null
  
)

export default component.exports